const { html } = window;

export default({heading, src, isLuckyDay, useNewPopover}) => `
    <div id="now-unavailable-modal-title" class="title-text">
        <div class="now-unavailable-text">${heading}
            ${isLuckyDay
                ? useNewPopover
                    ? `<div style="display: inline-block; position: relative">
                        <div style="display: inline-block; float: right">
                            <a role="button" id="luckyDayTooltip" class="help-tip secondary-background" style="float: right"></a>
                        </div>
                    </div>`
                    : `<div style="display: inline-block; position: relative">
                        <div style="display: inline-block; float: right">
                            <a role="button" data-dropdown="luckyDay-help-tip" aria-controls="luckyDay-help-tip" tabindex="0" class="help-tip secondary-background luckyDay-help-tip" style="float: right"></a>
                        </div>
                    </div>
                    <div id="luckyDay-help-tip" data-dropdown-content class="f-dropdown medium content" aria-hidden="true" tabindex="-1">
                        <p>${html('nowUnavailableModal.luckyDayInfo')}</p>
                    </div>`
            : ''}
        </div>
    </div>

    <div class="img-container">
        <img data-id="cover-image" src="${src}" alt="${html('coverImage')}"/>
    </div>

    <div class="medium-8 medium-centered columns button-container">
        <span class="TitleAction" />
        <button type="button" class="button js-cancel cancel radius u-allCaps outline gray">${html('cancel')}</button>
    </div>
`;
